/**
 * El SBU de consolas no llega igual en todos lados: "Consolas" en plural para Chile y México,
 * "Consola" en singular para Perú, y sin garantía de capitalización porque el nombre sale de la
 * BD de cada país. Comparar contra el string exacto (amarrado a VITE_COUNTRY) dejaba fuera al
 * seller cuya BD lo tuviera escrito distinto, así que la comparación se hace normalizada.
 */
export const isConsole = (sbu: string | null | undefined): boolean => {
  const nombre = String(sbu ?? '').trim().toLowerCase()
  return nombre === 'consola' || nombre === 'consolas'
}
